import { render, staticRenderFns } from "./EvrakTuruPicker.vue?vue&type=template&id=10b2315a&scoped=true"
import script from "./EvrakTuruPicker.vue?vue&type=script&lang=ts"
export * from "./EvrakTuruPicker.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b2315a",
  null
  
)

export default component.exports